<template>
    <div class="card-data amount-card sm" :class="isActive()" @click="$emit('changeRange', initRange, today, connectionBarChart)">
        <Tooltip 
            :tip="tip"
            :tooltipActive="tooltipActive"
        />
        <div class="card-title">
            <h5 class="title">{{title}}</h5>
        </div>
        <div v-if="!loader">
            <Loader/>
        </div>
        <!-- <div v-else-if="loader && total==0">
            <EmptyStateChart
            />
        </div> -->
        <div v-else-if="loader">
            <div v-if="loader" class="right" id="total">
                <div class="counter">
                    <ICountUp
                        :endVal="Number(total)"
                        :options="options(total)"
                        class="actual"
                        />
                    <i class="ico-up-triangle-fill indicator up" src="@/assets/icons/up.svg" alt="Indicador" v-if="amountUp"></i>
                    <i class="indicator ico-equals-fill equal" v-else-if="total==previous"></i>
                    <i class="ico-down-triangle-fill indicator down" alt="Indicador"  v-else></i>
                </div>
                <p class="detail">{{rangeTitle}}</p>
            </div>
            
            <div v-if="loaderPrevious" class="right">
                <ICountUp
                    :endVal="Number(previous)"
                    :options="options(previous)"
                    class="previous"
                    />
                <p class="detail">{{prevRangeTitle}}</p>
            </div>
        </div>
            
    </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import ICountUp from 'vue-countup-v2'
import Loader from '@/components/Loader'
import Tooltip from '@/components/Tooltip'
import EmptyStateChart from '@/components/EmptyStateChart'

import { mapActions } from 'vuex'
export default {
    name: 'AmountCard',
    components: {
        ICountUp,
        Loader,
        Tooltip,
        EmptyStateChart
    },
    props: {
        title: {
            type: String,
            required: true
        },
        today: {
            required: true
        },
        initRange: {
            required: true
        },
        initPrevious: {
            required: true
        },
        endPrevious: {
            required: true
        },
        selectedRange: {
            required: true
        },
        store_id: {
            required: true
        },
        tip: {
            type: String,
            required: true
        },
        md: {
            type: Boolean,
            required: false
        },
        captionEmpty:{
            type: String,
            default: "Puedes consultar la vista de los últimos 7 o 30 días.",
        },
        titleEmpty: {
            type: String,
            default: "Este gráfico no esta disponible para esta vista"
        }
    },
    data: function(){
        return {
            total: 0,
            previous: 0,
            completeTotal: 0,
            completePrevious: 0,
            connectionBarChart: [],
            loader: false,
            loaderPrevious: false,
            tooltipActive: false,
        }
    },
    computed: {
        amountUp: function() {
            return (this.completeTotal > this.completePrevious) ? true : false;
        },
        rangeTitle: function(){
            let monthNames = [
                                "Ene", "Feb", "Mar",
                                "Abr", "May", "Jun", "Jul",
                                "Ago", "Sep", "Oct",
                                "Nov", "Dic"
                            ]
            if (this.initRange != this.today) {
                return this.initRange.split('-')[2] +
                    "-" +
                    monthNames[this.initRange.split('-')[1] - 1] +
                    " al " +
                    this.today.split('-')[2] +
                    "-" +
                    monthNames[this.today.split('-')[1] - 1]
            }
            return this.initRange.split('-')[2] +
                    "-" +
                    monthNames[this.initRange.split('-')[1] - 1]
        },
        prevRangeTitle: function(){
            let monthNames = [
                                "Ene", "Feb", "Mar",
                                "Abr", "May", "Jun", "Jul",
                                "Ago", "Sep", "Oct",
                                "Nov", "Dic"
                            ]
            if (this.initPrevious != this.endPrevious) {
                return this.initPrevious.split('-')[2] +
                    "-" +
                    monthNames[this.initPrevious.split('-')[1] - 1] +
                    " al " +
                    this.endPrevious.split('-')[2] +
                    "-" +
                    monthNames[this.endPrevious.split('-')[1] - 1]
            }
            return this.initPrevious.split('-')[2] +
                    "-" +
                    monthNames[this.initPrevious.split('-')[1] - 1]
        }
    },
    methods: {
        isActive: function(){
            if(this.selectedRange==this.initRange){
                this.tooltipActive = true
                return 'active'
            }else{
                this.tooltipActive = false
                return ''
            }
        },
        showData: function(){
            this.loader = false
            this.loaderPrevious = false
            if (this.initRange == moment().subtract(29, 'd').format('YYYY-MM-DD')){
                this.changeMaxRange(true)
            } else {
                this.changeMaxRange(false)
            }
            let headers = {
                'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
            }
            axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/sessions/?init_date="+this.initRange+"&end_date="+this.today+"&store_id="+this.store_id, {
                headers: headers
            })
                .then((res) => {
                    let sumConnection = 0;
                    _.each(res.data, (value, index) => {
                        sumConnection = sumConnection + value.not_customer + value.customer
                    })
                    
                    this.connectionBarChart = res.data
                    this.loader = true
                    this.total = sumConnection
                    this.completeTotal = sumConnection

                    this.showPrevious()
                })
                .catch((err) => {
                    console.log(err)
                    this.loader = false;
                })
        },
        showPrevious: function(){
            let headers = {
                'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
            }
            axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/sessions/?init_date="+this.initPrevious+"&end_date="+this.endPrevious+"&store_id="+this.store_id, {
                headers: headers
            })
                .then((res) => {
                    let sumConnection = 0;
                    _.each(res.data, (value, index) => {
                        sumConnection = sumConnection + value.not_customer + value.customer
                    })
                    
                    this.loader = true
                    this.previous = sumConnection
                    this.completePrevious = sumConnection
                    if (this.initRange == this.selectedRange) {
                        this.$emit('changeRange', this.initRange, this.today, this.connectionBarChart)
                    }
                    this.loaderPrevious = true;
                })
                .catch((err) => {
                    console.log(err)
                    this.loader = false;
                    this.loaderPrevious = false;
                })
        },
        options: function(num){
            if (num > 999999){
                if (num == this.total) {
                    this.total = (this.total / 1000000).toFixed(1)
                }else if (num == this.previous) {
                    this.previous = (this.previous / 1000000).toFixed(1)
                }
                return {
                    useEasing: true,
                    useGrouping: true,
                    duration: 0.6,
                    separator: '.',
                    decimalPlaces: 1,
                    decimal: ',',
                    prefix: '',
                    suffix: ' MM'
                }
            }
            return {
                useEasing: true,
                useGrouping: true,
                duration: 0.6,
                separator: '.',
                decimal: ',',
                prefix: '',
                suffix: ''
            }
        },
        ...mapActions('auth', [
            'changeMaxRange'
        ])
    },
    mounted: function(){
        this.showData()
    },
    watch: {
        store_id: function(val) {
            this.showData()
        }
    }
}
</script>
​
<style lang="sass">
.card-data.amount-card .actual
    font-family: $title-font
    font-size: 40px
    font-weight: 600
    text-align: right
    color: $dark
    @include mobile
        font-size: 22px
        margin-top: $xs
    @include tablet-landscape
        font-size: 28px
    @include tablet-portrait
        font-size: 22px

​
.card-data.amount-card .indicator
    margin-left: $sm
    color: $danger
    height: 18px
    width: 18px
    &.down
        color: $danger
    &.equal
        color: $warning
    &.up
        color: $success
    @media mobile
        margin-left: $xs

.card-data.amount-card .previous
    opacity: 0.7
    font-family: $title-font
    font-size: 24px
    font-weight: 600
    text-align: right
    display: block
    width: 100%
    color: $dark
    @include mobile
        font-size: 18px
    @include tablet-landscape
        font-size: 18px
    @include tablet-portrait
        font-size: 18px
// TODO: esta clase parece que esta dos veces
.card-data.amount-card .detail
    font-family: $body-font
    font-size: 12px
    font-weight: 300
    text-align: right
    color: $dark
    margin-bottom: 12px
    width: 100%
​
</style>